// extracted by mini-css-extract-plugin
export default {"container":"l_g","description":"l_c"};